import {Alpine as AlpineType} from 'alpinejs';

export default (Alpine: AlpineType) => {
  Alpine.data('mobileMenu', () => ({
    isOpen: false,
    isTyping: false,
    typingTimeout: null,
    charIndex: 0,
    wordIndex: 0,
    words: ["Coffee ", "Focus ", "Gut Health "],
    formElement: null,
    placeholder: null,

    open() {
      const header = document.querySelector('header.header .header__wrapper');
      if (header != null) {
        document.body.style.setProperty('--lsg-header-height', `${header.offsetHeight}px`);
      }
      document.body.style.overflow = 'hidden';
      this.isOpen = true;
      document.body.classList.add('is-mobile-menu-open');

      const gorgiasChat = document.getElementById('gorgias-chat-container');
      if (gorgiasChat) {
        gorgiasChat.style.display = 'none';
      }
      this.startTyping();
    },
    close() {
      this.isOpen = false;
      document.body.style.overflow = '';
      document.body.classList.remove('is-mobile-menu-open');

      const gorgiasChat = document.getElementById('gorgias-chat-container');
      if (gorgiasChat) {
        gorgiasChat.style.display = 'block';
      }
      this.stopAnimation();
    },
    stopAnimation() {
      this.isTyping = false;
      if (this.placeholder) {
        clearTimeout(this.typingTimeout);
        this.placeholder.innerHTML = "";
      }
    },

    startTyping() {
      this.placeholder = document.querySelector('.js-lsg-form-element-placeholder');
      if (!this.placeholder) return;
      if (this.isTyping) return;
      this.isTyping = true;
      this.charIndex = 0;
      this.typeWordAnimation();
    },
    typeWordAnimation() {
      this.placeholder.style.display = "flex";
      const word = this.words[this.wordIndex];

      if (this.charIndex <= word.length) {
        this.placeholder.innerHTML = word.substring(0, this.charIndex);
        this.charIndex++;
        this.typingTimeout = setTimeout(() => this.typeWordAnimation(), 100);
      } else {
        this.charIndex = 0;
        const isLastWord = this.wordIndex === this.words.length - 1;
        this.wordIndex = (this.wordIndex + 1) % this.words.length;
        const delay = isLastWord ? 2000 : 1500;
        if(delay == 2000){
          setTimeout(()=>{  this.placeholder.innerHTML ="";},1000)
        }
        this.typingTimeout = setTimeout(() => {
          this.typeWordAnimation();
        }, delay);
      }
    },

  }));
};
